/** Supported single-division group sizes for match generation (each team plays 6). */
export const SUPPORTED_GROUP_SIZES = [4, 6, 8, 10, 12, 14];

export const MAX_SUPPORTED_GROUP_SIZE = 14;

/** Optional Split into Groups becomes available from this team count (inclusive). */
export const SPLIT_AVAILABLE_FROM = 10;

export const SUPPORTED_GROUP_SIZES_LABEL = '4, 6, 8, 10, 12, or 14';

export function isOptimalGroupSize(teamCount) {
  return SUPPORTED_GROUP_SIZES.includes(Number(teamCount));
}
